import { isTestVoterCardBarcode, isTestVoterCardWithPrefixOrSuffixBarcode } from "./barcode-utils";

export class BarcodeScanner extends EventTarget {
    private static readonly TIMEOUT_MS = 200; 
    private static readonly MIN_CHAR_COUNT = 12;
    private static readonly VOTER_NUMBER_LENGTH = 16;
    private static readonly ENTER_KEY = "Enter";

    private capture = "";
    private timer?: number;

    constructor() {
        super();
        window.addEventListener("keypress", this.handleKeyPress.bind(this));
    }

    private handleKeyPress(event: KeyboardEvent): void {
        if (event.key === BarcodeScanner.ENTER_KEY) {
            this.processCapture();
            return;
        }

        if (!this.timer) {
            this.reset();
        }

        if (event.key.length === 1) { // capture only digits and alphabetical letters, filter out special keys
            this.capture += event.key;
        }

        clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.processCapture(), BarcodeScanner.TIMEOUT_MS);
    }

    private processCapture(): void {
        if (this.capture.length < BarcodeScanner.MIN_CHAR_COUNT) {
            this.reset();
            return;
        }

        if (isTestVoterCardWithPrefixOrSuffixBarcode(this.capture)) {
            this.dispatchEventWithReset("scanTestVoterCardWithPrefixOrSuffix");
            return;
        }

        if (isTestVoterCardBarcode(this.capture)) {
            this.dispatchEventWithReset("scanTestVoterCard");
            return;
        }

        if (this.isValidVoterNumber()) {
            this.dispatchVoterNumberEvent();
            return;
        }

        this.dispatchEventWithReset("scan");
    }

    private isValidVoterNumber(): boolean {
        return (
            this.capture.length === BarcodeScanner.VOTER_NUMBER_LENGTH &&
            this.capture.charAt(0) !== "9" &&
            /^\d+$/.test(this.capture.slice(9)) // Ensure last part is numeric digits for the voter number
        );
    }

    private dispatchVoterNumberEvent(): void {
        const voterNumber = this.capture.slice(9); // Extract voter number
        this.dispatchEventWithReset("scanVoterNumber", voterNumber);
    }

    private dispatchEventWithReset(eventName: string, detail: string = this.capture): void {
        this.dispatchEvent(new CustomEvent(eventName, { detail }));
        this.reset();
    }

    private reset(): void {
        this.capture = "";
        clearTimeout(this.timer);
        this.timer = undefined;
    }
}
